import MentionDecorator from "./mention";
const nodeViewDecorators = [MentionDecorator];
export {
  nodeViewDecorators
};
//# sourceMappingURL=index.js.map
